import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';

import { getLastOperation } from 'modules/transactions/api/getLastOperation';
import { operationLabels } from 'modules/transactions/pages/OperationDetails/constants/operationLabels';

import { rollbackValidOperations } from '../constants/rollbackValidOperations';

type UseGetLastOperationDataProps = {
  societyId: string;
};

export const useGetLastOperationData = ({
  societyId,
}: UseGetLastOperationDataProps) => {
  const [operationId, setOperationId] = useState<string>('');
  const [operationTypeLabel, setOperationTypeLabel] = useState<string>('');
  const [date, setDate] = useState<string>('');
  const [isRollbackDisabled, setIsRollbackDisabled] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchLastOperation = useCallback(async () => {
    if (!societyId) return;

    try {
      setIsLoading(true);
      const lastOperation = await store.dispatch(
        getLastOperation({ societyId })
      );

      if (!lastOperation) {
        setIsLoading(false);
        return;
      }

      const { _id, operationType, date } = lastOperation;

      setOperationId(_id);

      setIsRollbackDisabled(!rollbackValidOperations.includes(operationType));

      const operationTypeLabel =
        operationLabels[operationType] || operationType;
      setOperationTypeLabel(operationTypeLabel);

      const formattedDate = format(new Date(date), 'dd-MM-yyyy');
      setDate(formattedDate);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [societyId]);

  useEffect(() => {
    fetchLastOperation();
  }, [fetchLastOperation]);

  return {
    data: {
      operationId,
      operationTypeLabel,
      date,
      isRollbackDisabled,
    },
    isLoading,
  };
};
